export const GET_BUSINESS_CLINIC_LIST = "GET_BUSINESS_CLINIC_LIST"
export const CLEAR_BUSINESS_CLINIC_LIST = "CLEAR_BUSINESS_CLINIC_LIST"